/** 综合 PO：Tab / 表头（按 online 库真实字段与 data 结构定制） */

const JSON_COL = 'data';
const TIME_COLS = ['dataTime', 'expireTime', 'createTime', 'rushTicketTime'];

/** 详情列紧跟工单号列：1 个工单号 → 第 2 列；2 个 → 第 3 列 */
function reorderColumnsWithDetail(columns, ticketColumnProps) {
  const detailCol = columns.find((c) => c.prop === JSON_COL);
  if (!detailCol || !ticketColumnProps?.length) return columns;
  const ticketSet = new Set(ticketColumnProps);
  const ticketCols = ticketColumnProps
    .map((p) => columns.find((c) => c.prop === p))
    .filter(Boolean);
  const otherCols = columns.filter((c) => c.prop !== JSON_COL && !ticketSet.has(c.prop));
  return [...ticketCols, detailCol, ...otherCols];
}

function defineTab(tab) {
  const ticketColumnProps = tab.ticketColumnProps || [tab.ticketProp];
  const { ticketColumnProps: _drop, ...rest } = tab;
  return {
    ...rest,
    columns: reorderColumnsWithDetail(tab.columns, ticketColumnProps),
  };
}

const PO_OTHER_TABS_RAW = [
  {
    name: 'networkRush',
    label: '网络催单',
    api: 'poOtherNetworkRush',
    tableTitle: '网络催单',
    ticketProp: 'RushTicketid',
    ticketColumnProps: ['RushTicketid'],
    search: { showSrcTicket: false, showScene: false },
    columns: [
      { prop: 'RushTicketid', label: '催办工单号', width: 150 },
      { prop: 'Message', label: '催办消息', minWidth: 200 },
      { prop: 'Title', label: '标题', minWidth: 180 },
      { prop: 'bizAreaName', label: '一级机房', width: 150 },
      { prop: 'ticketType', label: '工单类型', width: 100 },
      { prop: 'ticketNo', label: '上游单号', width: 150 },
      { prop: 'creator', label: '建单人', width: 110 },
      { prop: 'handler', label: '当前责任人', width: 130 },
      { prop: 'supplyName', label: '服务商', width: 100 },
      { prop: 'deal', label: '运营管理员', width: 110 },
      { prop: 'rushTicketTime', label: '催办时间', width: 170 },
      { prop: 'isDelay', label: '是否超时', width: 90 },
    ],
  },
  {
    name: 'serverDiagnose',
    label: '服务器诊断',
    api: 'poOtherServerDiagnose',
    tableTitle: '服务器故障诊断',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid', 'srcTicketId'],
    search: { showSrcTicket: true, showScene: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: 'srcTicketId', label: '关联工单号', width: 150 },
      { prop: JSON_COL, label: '诊断明细', width: 100 },
      { prop: '_dcopsTicketId', label: 'DCOPS工单号', width: 120 },
      { prop: '_serverSn', label: '服务器SN', width: 150 },
      { prop: 'sceneName', label: '场景名称', width: 150 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 220 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: '_idcUnit', label: '机房单元', minWidth: 160 },
      { prop: 'slaLevel', label: 'SLA', width: 70 },
      { prop: '_taskTypeName', label: '任务类型', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
      { prop: 'expireTime', label: '超时时间', width: 170 },
    ],
  },
  {
    name: 'serverRepaire',
    label: '服务器维修',
    api: 'poOtherServerRepaire',
    tableTitle: '服务器故障维修',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid', 'srcTicketId'],
    search: { showSrcTicket: true, showScene: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: 'srcTicketId', label: '关联工单号', width: 150 },
      { prop: JSON_COL, label: '维修回执', width: 100 },
      { prop: 'sceneName', label: '场景名称', width: 150 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 220 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: 'slaLevel', label: 'SLA', width: 70 },
      { prop: '_respCode', label: '响应码', width: 90 },
      { prop: '_respDesc', label: '响应说明', width: 100 },
      { prop: '_callId', label: '呼叫ID', minWidth: 160 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
      { prop: 'expireTime', label: '超时时间', width: 170 },
    ],
  },
  {
    name: 'serverMoveInfo',
    label: '服务器搬迁',
    api: 'poOtherServerMoveInfo',
    tableTitle: '服务器搬迁计划',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid'],
    search: { showSrcTicket: true, showScene: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: JSON_COL, label: '机房计划明细', width: 120 },
      { prop: 'sceneName', label: '场景名称', width: 140 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 200 },
      { prop: '_planIdcCount', label: '涉及机房数', width: 110 },
      { prop: '_planTotal', label: '计划总量', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
  {
    name: 'poCost',
    label: 'PO计费计划',
    api: 'poOtherPoCost',
    tableTitle: 'PO计费确认计划',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid'],
    search: { showSrcTicket: true, showScene: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: JSON_COL, label: '计费明细', width: 100 },
      { prop: 'sceneName', label: '场景名称', width: 160 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 220 },
      { prop: '_billingLineCount', label: '计费行数', width: 100 },
      { prop: '_billingTotalQty', label: '数量合计', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
  {
    name: 'directDispatch',
    label: '服务器直配',
    api: 'poOtherDirectDispatch',
    tableTitle: '服务器直配计划',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid'],
    search: { showSrcTicket: true, showScene: true, showSupplier: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: JSON_COL, label: '直配明细', width: 100 },
      { prop: 'sceneName', label: '场景名称', width: 140 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 180 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: 'supplierName', label: '服务商', width: 100 },
      { prop: '_dispatchLineCount', label: '工单条数', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
  {
    name: 'itReformCheck',
    label: '改造服务器',
    api: 'poOtherItReformCheck',
    tableTitle: '改造服务器计划',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid', '_reformTicketId'],
    search: { showSrcTicket: true, showScene: true, showSupplier: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: '_reformTicketId', label: '改造工单号', width: 150 },
      { prop: JSON_COL, label: '改造明细', width: 100 },
      { prop: '_reformServerSn', label: '服务器SN', width: 150 },
      { prop: 'sceneName', label: '场景名称', width: 120 },
      { prop: '_reformIdc', label: '机房', minWidth: 180 },
      { prop: 'supplierName', label: '服务商', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
  {
    name: 'serverRepaireAdjustSla',
    label: '故障工单调级',
    api: 'poOtherServerRepaireAdjustSla',
    tableTitle: '服务器故障工单调级',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid', 'srcTicketId'],
    search: { showSrcTicket: true, showScene: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: 'srcTicketId', label: '关联工单号', width: 150 },
      { prop: JSON_COL, label: '推送数据', width: 100 },
      { prop: 'sceneName', label: '场景名称', width: 160 },
      { prop: 'dataMemo', label: '数据说明', minWidth: 200 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: 'slaLevel', label: 'SLA', width: 70 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
  {
    name: 'crossAuditPush',
    label: '交叉审计推送',
    api: 'poOtherCrossAuditPush',
    tableTitle: '服务商交叉审计结果',
    ticketProp: 'opTicketid',
    ticketColumnProps: ['opTicketid', 'reviewTicketId'],
    search: { showSrcTicket: true, showScene: true, showSupplier: true, showReviewTicket: true },
    columns: [
      { prop: 'opTicketid', label: 'PO单号', width: 150 },
      { prop: 'reviewTicketId', label: '复核单号', width: 150 },
      { prop: JSON_COL, label: '推送明细', width: 100 },
      { prop: 'finalResult', label: '终审结果', width: 100 },
      { prop: 'finalRemark', label: '终审备注', minWidth: 160 },
      { prop: 'idcpName', label: '一级机房', width: 140 },
      { prop: 'supplierName', label: '服务商', width: 100 },
      { prop: 'dataTime', label: '生成时间', width: 170 },
    ],
  },
];

export const PO_OTHER_TABS = PO_OTHER_TABS_RAW.map(defineTab);

export const PO_OTHER_JSON_COLS = [JSON_COL];
export const PO_OTHER_TIME_COLS = TIME_COLS;

export function getPoOtherTab(name) {
  return PO_OTHER_TABS.find((t) => t.name === name) || PO_OTHER_TABS[0];
}
